import {
  styled,
  Typography as MuiTypography,
  Box as MuiBox,
  IconButton as MuiIconButton
} from "@mui/material";

export const Wrapper = styled(MuiBox)(
  ({
    theme: {
      palette: { custom },
      breakpoints
    }
  }) => `
    &.MuiBox-root {
      background-color: ${custom.background};
      border-radius: 4px;
      padding: 16px 0;
      margin: 20px 0;

      ${breakpoints.up("sm")} {
        margin: 20px 16px;
      }

      ${breakpoints.up("md")} {
        margin: 20px 20px;
      }

      ${breakpoints.up("lg")} {
        margin: 20px 32px;
      }
    }
  `
);

export const Title = styled(MuiTypography)(
  ({
    theme: {
      palette: { custom },
      typography: { h3 }
    }
  }) => `
    &.MuiTypography-root {
      font-size: ${h3.mobile.fontSize};
      line-height: ${h3.mobile.lineHeight};
      font-weight: ${h3.mobile.fontWeight};
      color: ${custom.white.main};
      margin: 13px 16px;
    }
  `
);

export const ToolboxWrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      padding: 16px;
      display: flex;
      flex-direction: column;

      ${breakpoints.up("md")} {
        flex-direction: row;
        align-items: center;
      }
    }
  `
);

export const SearchWrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      width: 100%;
      margin-bottom: 18px;

      ${breakpoints.up("md")} {
        margin-right: auto;
        width: 300px;
      }
    }
  `
);

export const ButtonsWrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      display: flex;
      gap: 16px;
      flex-direction: row;
      align-items: center;

      & > .MuiButton-root {
        width: auto;
        flex: 1;
        height: 31px;
      }

      ${breakpoints.up("md")} {
        margin-left: auto;
        flex-direction: row;
        align-items: center;

        & > .MuiButton-root {
          width: 240px;
        }
      }
    }
  `
);

export const IconButton = styled(MuiIconButton)(
  ({
    theme: {
      palette: { custom }
    }
  }) => `
    &.MuiIconButton-root {
      color: ${custom.white.light};
      width: 40px;
      height: 40px;

      &.Mui-disabled {
        color: ${custom.white.dark};
      }
    }
  `
);
